import { Link, LinkButton, LinkIconButton } from '../Link';
import { EnterprisePaths, enterpriseRoutePrefix, ParamsProps, SearchProps } from './types';

type EnterpriseLinkProps<To extends EnterprisePaths, From> = {
    to: To;
    from?: From;
    hash?: string;
    children: React.ReactNode;
} & ParamsProps<To> &
    SearchProps<To, From>;

type OverridenProps = keyof EnterpriseLinkProps<EnterprisePaths, unknown>;

export const EnterpriseLink = <To extends EnterprisePaths, From extends string>({
    to,
    ...rest
}: EnterpriseLinkProps<To, From> & Omit<React.ComponentProps<typeof Link>, OverridenProps>) => (
    <Link to={`${enterpriseRoutePrefix}${to}`} {...(rest as React.ComponentProps<typeof Link>)} />
);

export const EnterpriseLinkButton = <To extends EnterprisePaths, From extends string>({
    to,
    ...rest
}: EnterpriseLinkProps<To, From> & Omit<React.ComponentProps<typeof LinkButton>, OverridenProps>) => (
    <LinkButton to={`${enterpriseRoutePrefix}${to}`} {...(rest as React.ComponentProps<typeof LinkButton>)} />
);

export const EnterpriseLinkIconButton = <To extends EnterprisePaths, From extends string>({
    to,
    ...rest
}: Omit<EnterpriseLinkProps<To, From>, 'children'> &
    Omit<React.ComponentProps<typeof LinkIconButton>, OverridenProps>) => (
    <LinkIconButton to={`${enterpriseRoutePrefix}${to}`} {...(rest as React.ComponentProps<typeof LinkIconButton>)} />
);
